exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#additionalInformationButton{-webkit-box-shadow:none!important;box-shadow:none!important}#additionalInformationButton i{display:none!important}#additionalInformationButton.collapsed .open-icon,#additionalInformationButton:not(.collapsed) .close-icon{display:inline-block!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5085b412","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/layout/FineDetailsModal.vue
// module id = 462
// module chunks = 0